<template>
  <el-upload
    :action="uploadBaseUrl"
    :data="extraData"
    :on-success="afterUpload"
    :on-remove="removeFile"
    :limit="limit"
    with-credentials
    :accept="accept"
    :file-list="getFileList"
  >
    <slot></slot>

  </el-upload>

</template>

<script>
import FileUrlMixin from "@/mixins/FileUrlMixin";
import config from "@/config/ApiConfig";
export default {
  mixins: [FileUrlMixin],
  props: {
    accept: {
      type: String,
      // default: "application/vnd.ms-excel",
      default: ""
    },
    extraData: {
      type: Object
    },
    limit: {
      type: Number,
      default: 1
    },
    fileUrl: {
      type: String
    }
  },
  computed: {
    getFileList() {
      if (this.fileUrl) {
        return [{ name: this.fileUrl, url: this.fileUrl }];
      }
      return [];
    }
  },
  methods: {
    afterUpload(res, file) {
      var { filePath } = res.data;
      //res.data.filePath = config.apiServer +'/'+ filePath;
      this.$emit("uploadSuccess", res.data);
    },
    removeFile() {
      this.$emit("uploadSuccess", { filePath: "" });
    }
  }
};
</script>
